module.exports = "query chancelleryLocations{chancelleryLocations{list{id chancelleryId}}}"